export function normalizeDateRange(
  from: Date,
  to: Date,
): {
  from: Date;
  to: Date;
} {
  const start = from.getTime() <= to.getTime() ? from : to;
  const end = from.getTime() <= to.getTime() ? to : from;
  return { from: start, to: end };
}
